import { mapActions } from 'vuex';

//---helpers
import { globalLoader } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import ContentBlock from '@/components/custom/ContentBlock/index.vue';

export default {
  name: 'DeliveryInfo',
  mixins: [dynamicHead],
  components: { ContentBlock, BreadcrumbsSimple },
  props: {},
  data() {
    return {
      pageData: null
    };
  },
  created() {
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getPage: 'staticPages/GET_PAGE'
    }),
    async _loadContent() {
      globalLoader(true);

      this.pageData = await this.getPage('delivery-and-payment');
      this._setMetaParams();
      this.setMeta();
      globalLoader(false);
    },
    _setMetaParams() {
      let { metaTitle, title, metaDescription, image } = this.pageData;
      if (title || metaTitle)
        this.metaParams.title = `${metaTitle ? metaTitle : title}${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = `${metaDescription ? metaDescription : title} ${this.$t('seo.metaDescGeneral')}`;

      if (image) this.metaParams.image = image;
    }
  }
};
